/* Domovoi · what your partner guessed you'd say yes to (Would Olya?, 0061), for the decks' label: a thing they
   guessed yes on reads "Ben thinks you'll say yes" instead of "Ben said yes". Keys are `kind:item` — watch:movie:603,
   cook:<recipe id>, out:<place id>. Read once every five minutes; a failure is no labels, never an error.

   Side-effect free: products may import it (see AGENTS.md). */
import { supabase, currentSession } from './supabase.js';

let kept = null, at = 0;

export function guessedYes() {
  if (kept && Date.now() - at < 5 * 60000) return kept;
  at = Date.now();
  kept = (async () => {
    const s = await currentSession();
    if (!s || !s.user) return new Set();
    const { data, error } = await supabase().from('game_guesses').select('kind, item').eq('about', s.user.id).eq('guess', 'yes').eq('unseen', true);
    if (error) return new Set();
    return new Set((data || []).map((r) => r.kind + ':' + r.item));
  })().catch(() => new Set());
  return kept;
}

export const guessKey = { watch: (type, id) => 'watch:' + type + ':' + id, cook: (id) => 'cook:' + id, out: (id) => 'out:' + id };
